export default __webpack_public_path__ + "static/media/Montserrat-MediumItalic.16663c3f.woff";